import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Form, TextInput, TextArea, Button, Loading, FileUploaderButton, FileUploaderItem, Checkbox } from 'carbon-components-react';
import { toaster } from '../../helpers/toaster';
import Select from 'react-select';
import CreatableSelect from "react-select/creatable";

import MyModal from '../../components/Modal/Modal';
import Label from '../../components/Label/Label';
import { selectStyles } from '../../helpers/formUtils'
// api
import { addCondition, updateCondition } from '../../api/conditions';
import { getSimpleStudyList } from '../../api/studyListApi';
import { getSimpleConditions } from '../../api/conditions';

const ConditionDetailModal = ({
  mode,
  conditionId = null,
  open = false,
  name = "",
  synonyms = [],
  parentCondition = [],
  studies = [],
  refreshConditions = () => { },
  onClose = () => { },
  refreshData,
  description = "",
  additionalInfo = {},
  imageData = {},
}) => {
  // loading is for initial component preloading
  const [loading, setLoading] = useState(true);

  // processing is for user initiated component api calls
  const [processing, setProcessing] = useState(false);
  const [imageInfo, setImageInfo] = useState({});
  const [conditionName, setConditionName] = useState("");
  const [conditionDescription, setConditionDescription] = useState("")
  const [conditionSynonyms, setConditionSynonyms] = useState([]);
  const [rootCondition, setRootCondition] = useState([]);
  const [conditionStudies, setConditionStudies] = useState([]);
  const [refreshSimpleConditions, setRefreshSimpleConditions] = useState(null);
  const [hideMenu, setHideMenu] = useState(false)
  const [modalMode, setModalMode] = useState("");
  // store api response
  const [studyList, setStudyList] = useState([]);
  const [conditionList, setConditionList] = useState([]);
  const [imageFile, setImageFile] = useState();
  // const [conditionSynonymList, setConditionSynonymList] = useState([])
  // useEffect(() => {
  //   setConditionSynonyms(synonyms);
  // })
  const onlyAttachment = localStorage.getItem('only_attachment')

  // TODO: RESET MODAL INFO FOR OTHERS, CONDITIONS + INTERVENTIONS ARE THE ONLY ONES DONE FOR NOW
  const resetModalInfo = () => {
    setConditionName("")
    setRootCondition([])
    setImageFile()
    setConditionDescription("")
    setConditionSynonyms([])
    setConditionStudies([])
  }
  const onStudyListChange = (items) => {
    setConditionStudies(items);
  };

  const onConditionListChange = (items) => {
    setRootCondition([items[items.length - 1]]);
  };

  const onSynListChange = (items) => {
    setConditionSynonyms(items);
  };

  const changeConditionName = (name) => {
    setConditionName(name);
  };

  const changeConditionDescription = (name) => {
    setConditionDescription(name);
  };

  const changeConditionSyn = (name) => {
    setConditionSynonyms(name);
  };

  const saveCondition = (e) => {
    // form will handle most of validation, so button type="submit" thats why we preventDefault
    e.preventDefault();

    if (!conditionName) {
      toaster("Condition name is not valid", "warning")
      return;
    }

    setProcessing(true);
    let formData = new FormData();
    // convert selected conditions, studies to id array
    // let conditionIdArray = [];
    // if (conditionSynonyms && conditionSynonyms.length) {
    //   conditionIdArray = conditionSynonyms.map(item => {
    //       return ({ id: item.value })
    //     }
    //   );
    // }

    let studyIdArray = [];
    if (conditionStudies && conditionStudies.length) {
      studyIdArray = conditionStudies.map(item => {
        return ({ id: item.value })
      }
      );
    }

    let conditionIdArray = [];
    if (conditionSynonyms && conditionSynonyms.length) {
      conditionIdArray = conditionSynonyms.map(item => {
        return ({ id: item.value })
      }
      );
    }
    formData.append('name', conditionName)
    formData.append('synonyms', JSON.stringify(conditionSynonyms.map(syn => ({id: syn["value"]}))))
    formData.append('studies', JSON.stringify(studyIdArray))
    if(rootCondition && rootCondition[0] !== undefined){
      formData.append('root_condition', JSON.stringify(rootCondition.map(item => ({ id: item.value }))))
    }
    else{
      formData.append('root_condition', JSON.stringify([]))
    }

    // formData.append('root_condition', rootCondition.map(item => ({ id: item.value })))
    if (imageFile) {
      formData.append('image', imageFile, imageFile.name)
    }
    let additional_info_obj = {
      hideMenu: hideMenu
    }
    
    if (conditionDescription) {
      additional_info_obj.description = conditionDescription
    }
    formData.append("additional_info", JSON.stringify(additional_info_obj))
    if (modalMode === "create") {
      addCondition(formData).then(res => {
        toaster("Condition created successfully", "success")

        onClose();
        setProcessing(false);
        refreshConditions();
        resetModalInfo()
        setRefreshSimpleConditions(true);
      })
        .catch(error => {
          if (error.message === 'Request failed with status code 400') {
            toaster("Failed to add condition: condition already exists", "error")
          }
          else {
            toaster("Failed to add condition", "error")
          }
          setProcessing(false);
        });
    } else {
      updateCondition(conditionId, formData).then(res => {
        toaster("Condition updated successfully", "success")

        setProcessing(false);
        onClose();
        refreshConditions();
        resetModalInfo()
        setRefreshSimpleConditions(true);
      }).catch(error => {
        console.log(error)
        toaster("Failed to update condition", "error")
        setProcessing(false);
      });
    }
  };

  useEffect(() => setImageInfo(imageData), [imageData]);
  useEffect(() => setConditionName(name), [name, open]);
  useEffect(() => {
    setHideMenu(additionalInfo?.hideMenu)
    setConditionDescription(additionalInfo?.description)
  }, [additionalInfo]);
  // useEffect(() => (description), [description]);
  useEffect(() => setModalMode(mode), [mode]);

  // Reset loading state when modal opens to ensure fresh data load
  useEffect(() => {
    if (open) {
      setLoading(true);
    }
  }, [open]);

  useEffect(() => {
    let newSynonymList = synonyms.map(element => {
      return ({
        value: element?.label?.id,
        label: element?.label?.name
      })
    })
    setConditionSynonyms(newSynonymList);

  }, [synonyms]);

  useEffect(() => {
    let selParentCondition = []
    if (parentCondition && conditionList.length) {
      selParentCondition = conditionList.filter(ele => {
        return parentCondition === (ele.value) || parentCondition === (parseInt(ele.value))
      });
    }
    setRootCondition(selParentCondition);
  }, [parentCondition, conditionList, open]);

  useEffect(() => {
    let selectedStudies = [];
    if (studies && studies.length && studyList.length) {
      selectedStudies = studyList.filter(ele => studies.includes(ele.value));
    }
    setConditionStudies(selectedStudies);
  }, [studies, studyList]);

  useEffect(() => {
    if (!open) return; // Only fetch when modal is open

    // Only fetch if lists are empty or refresh is requested
    const needsFetch = studyList.length === 0 || conditionList.length === 0 || refreshSimpleConditions;

    if (!needsFetch) {
      setLoading(false);
      setProcessing(false);
      return;
    }

    getSimpleStudyList().then(res => {
      if (res && res.length) {
        let studies = res.map(item => ({
          value: item.id,
          label: item.org_study_id,
        }));
        setStudyList(studies);
      }
      getSimpleConditions().then(res => {
        if (res && res.length) {
          let conditions = res.map(item => ({
            value: item.id,
            label: item.name,
          }));
          setConditionList(conditions);

          setLoading(false);
          setProcessing(false);
        } else {
          setConditionList(res);

          setLoading(false);
          setProcessing(false);
        }
      }).catch(error => {
        toaster("Failed to get condition list", "error")

        setLoading(false);
        setProcessing(false);
      });
    }).catch(error => {
      toaster("Failed to get study list", "error")
      setLoading(false);
      setProcessing(false);
    });
    setRefreshSimpleConditions(false);


  }, [open, refreshSimpleConditions, refreshData]);

  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
    width: "fit-content",
    marginLeft: "18px"
  };


  const additionalProps = {
    className: 'some-class',
    onSubmit: saveCondition
  };

  return (
    <MyModal
      modalHeading="Condition Details"
      size="sm"
      open={open}
      onRequestClose={() => {
        resetModalInfo();
        onClose();
      }}
    >
      <ConditionModalContent>

        {
          processing || loading ?
            <Loading />
            :
            <></>
        }

        <Form {...additionalProps}>

          <PartWrapper>
            <Label>Name*</Label>
            <InputWrapper>
              <TextInput
                value={conditionName}
                // placeholder="Enter Condition Name"
                onChange={e => changeConditionName(e.target.value)}
                required
              />
            </InputWrapper>
          </PartWrapper>
          {onlyAttachment !== "true" &&
            <>
              <PartWrapper>
                <Label>Related Studies</Label>
                <InputWrapperRelated>
                  <Select
                    options={studyList}
                    isMulti
                    placeholder=""
                    onChange={e => onStudyListChange(e)}
                    value={conditionStudies}
                    classNamePrefix="xogene"
                    className="multi-select"
                    styles={{
                      ...selectStyles(),
                      control: (base, state) => ({
                        ...selectStyles().control(base, state),
                        backgroundColor: '#d0d0d0',
                        cursor: 'not-allowed'
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: '#a8a8a8'
                      })
                    }}
                    isDisabled={true}
                  />
                </InputWrapperRelated>
              </PartWrapper>

              <PartWrapper>
                <Label>Root Condition</Label>
                <InputWrapper>
                  <Select
                    options={conditionList}
                    isMulti
                    onChange={e => onConditionListChange(e)}
                    value={rootCondition}
                    classNamePrefix="xogene"
                    className="multi-select"
                    styles={selectStyles()}
                  />
                </InputWrapper>
              </PartWrapper>
              { (rootCondition && rootCondition.length > 0 && rootCondition[0] !== undefined ) &&
                <PartWrapper>
                  <InputWrapper>
                    <Checkbox
                      id="checkbox"
                      labelText="Hide from Navigation menu"
                      checked={hideMenu}
                      onChange={(e) => {
                        // console.log(e)
                        setHideMenu(e)
                      }}
                    />
                  </InputWrapper>
                </PartWrapper>
              }
              <PartWrapper>
                <Label>Synonyms</Label>
                <InputWrapper>
                  <CreatableSelect
                    components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                    isMulti
                    options={conditionList}
                    onChange={items => setConditionSynonyms(items)}
                    value={conditionSynonyms}
                  />
                </InputWrapper>
              </PartWrapper>
              <PartWrapper>
                <Label>Description</Label>
                <InputWrapper>
                  <TextArea
                    value={conditionDescription}
                    // placeholder="Enter Condition Name"
                    onChange={e => changeConditionDescription(e.target.value)}
                    size="sm"
                  />
                </InputWrapper>
              </PartWrapper>
              <PartWrapper>
                <Label>Image File</Label>
                <FileUploadStyled>
                  <PartWrapper>
                    {mode !== "create" &&
                      // <PaddingWrapper>
                      <div style={{ "marginBottom": "18px" }}>
                        <span>Current File: </span>
                        <a href={imageInfo?.url} target="_blank">{imageInfo?.title}</a>
                      </div>
                    }
                    <FileUploaderButton
                      id="imageFile"
                      disableLabelChanges={true}
                      buttonKind="ghost"
                      labelText="Select a file to attach"
                      onChange={e => setImageFile(e.target.files[0])}
                      multiple={false}
                      required
                      disabled={loading}
                      accept={['.png', '.jpg', '.jpeg']}
                    />
                    {imageFile && <FileUploaderItem
                      name={imageFile?.name}
                      status="edit"
                      onDelete={e => setImageFile(null)}
                    />}
                  </PartWrapper>
                </FileUploadStyled>
              </PartWrapper>
            </>
          }




          <ModalFooter>
            <Button
              kind="secondary"
              onClick={() => {
                resetModalInfo();
                onClose();
              }}
              style={addBtnStyle}
            >Cancel</Button>

            <Button
              type="submit"
              kind="primary"
              // onClick={() => saveCondition()}
              style={addBtnStyle}
              disabled={onlyAttachment === "true"}
            >{(modalMode === "create") ? "Create Condition" : "Update Condition"}</Button>
          </ModalFooter>

        </Form>

      </ConditionModalContent>
    </MyModal>
  )
}

export default ConditionDetailModal;

const ConditionModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const PartWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 18px;
`

const InputWrapper = styled.div`
  width: 100%;
`
const InputWrapperRelated = styled.div`
  width: 100%;
  .xogene__multi-value__remove{
    display: none;
  }
  .xogene__indicators{
    display: none;
  }
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const FileUploadStyled = styled(InputWrapper)`
  background-color: #f4f4f4;
	padding-left: 1rem;
	padding-bottom: 1rem;
	padding-top: 1rem;
  // button
  .bx--btn--ghost {
    color: black;
    border: 1px solid #8d8d8d;
    border-radius: 5px;
    background-color: #d9d9d9;
  }

  .bx--btn--ghost:hover, .bx--btn--ghost:active {
    color: #0f62fe;
    border-color: #0f62fe;
  }

  .bx--file-container {
    width: 100%;
  }

  .bx--file__selected-file {
    border-bottom: 1px dotted black;
    color: black;
  }
`
